export default __webpack_public_path__ + "static/media/2.8bbb90a9.png";